export default class FormModifier {
  constructor(host) {
    this.host = host;
  }

  _changePlaceholder = () => {
    const textyInputs = this.host.querySelectorAll(
      "input[type='email'][title], input[type='text'][title], input[type='tel'][title]",
    );

    textyInputs.forEach(item => {
      item.placeholder = item.title;
    });
  };

  populate = () => {
    setTimeout(this._changePlaceholder);
  };
}
